<template>
  <div class="pd-VendorAvatar_VideoWrapper" @click="showVideo">
    <div class="pd-VendorAvatar_VideoBubble"></div>
    <div class="pd-VendorAvatar_VideoText">{{ text }}</div>
    <div class="pd-VendorAvatar_VideoButton fa fa-play"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "StoreVendorIntro_Button",
  props: {
    text: {
      required: true,
      type: String,
    },
  },
  methods: {
    ...mapActions({
      setVendorIntroShow: "productShow/setVendorIntroShow",
    }),
    showVideo() {
      this.setVendorIntroShow(true);
      this.$el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global.scss";

.pd-VendorAvatar_VideoWrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}

.pd-VendorAvatar_VideoBubble {
  position: absolute;
  border-radius: 50%;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 30px;
  transform: translate3d(-80%, -40%, 0);
  background: rgba($primary, $opacity-half-visible);
  transition: transform $transition-duration;
  .pd-VendorAvatar_Wrapper:hover & {
    transform: translate3d(-90%, -25%, 0) scale(1.05);
  }
}
.pd-VendorAvatar_VideoButton {
  position: absolute;
  border-radius: 50%;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 60px;
  transform: translate3d(-30%, -40%, 0);
  background-color: $white;
  box-shadow: $box-shadow-lg;
  color: $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform, background-color, color;
  transition-duration: $transition-duration;

  .pd-VendorAvatar_Wrapper:hover & {
    transform: translate3d(-20%, -30%, 0) scale(1.3);
    background-color: $primary;
    color: $white;
  }
}
.pd-VendorAvatar_VideoText {
  @include header-font-bold;
  border-radius: $border-radius;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translate3d(50%, 3%, 0) rotate(-6deg);
  background: $primary;
  padding: $padding-large-vertical;
  color: $white;
  box-shadow: $box-shadow-sm;
  text-transform: uppercase;
  transition: transform $transition-duration-long;
  .pd-VendorAvatar_Wrapper:hover & {
    transform: translate3d(60%, 10%, 0) rotate(-6deg) scale(1.05);
  }
}
</style>
